import React from 'react';

import * as Styled from './GradientLine.styles';

export interface GradientLineProps {}

const GradientLine: React.FC<GradientLineProps> = () => {
  return <Styled.Wrapper />;
};

export default GradientLine;
